<template>
  <div class="gameBlindsContent" id="blindContainer">
    <game-blinds-row v-for="(blind, index) in schedule" :key="index" :blind="blind" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { blindLevelTypes, numberWithCommas } from '../constants.js'
import { Duration } from 'luxon'
import GameBlindsRow from './Game-Blinds-Row'
const vueScrollTo = require('vue-scrollto')

export default {
  name: 'GameBlinds',
  components: {
    GameBlindsRow
  },
  computed: {
    ...mapState(['gameTimerGame', 'gameTimer']),
    schedule: function () {
      var levels = []
      var currentLevelIndex = this.gameTimer.blindCurrentIndex
      var timeSubTotal = 0

      if (this.gameTimerGame.hasOwnProperty('schedule') && this.gameTimerGame.schedule.hasOwnProperty('levels')) {
        for (let index = 0; index < this.gameTimerGame.schedule.levels.length; index++) {
          const element = this.gameTimerGame.schedule.levels[index]
          let level = {}
          level.minutes = element.m
          level.timeIndexLabel = Duration.fromObject({minutes: timeSubTotal}).toFormat('hh:mm')
          timeSubTotal += element.m
          if (element.t === blindLevelTypes.blind) {
            level.type = 'blind'
            level.message = numberWithCommas(element.b) + ' / ' + numberWithCommas(element.s)
          } else if (element.t === blindLevelTypes.break) {
            level.type = 'break'
            level.message = 'Color Up from ' + element.cf + ' to ' + element.ct + '.'
          }
          level.current = (index === currentLevelIndex)
          levels.push(level)
        }
      }
      return levels
    }
  },
  updated: function () {
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been re-rendered
      let options = {
        container: '#divBlinds',
        // easing: 'ease-in',
        // offset: -200,
        force: false,
        cancelable: false,
        /* onStart: function (element) {
          // scrolling started
        },
        onDone: function (element) {
          // scrolling is done
        },
        onCancel: function () {
          // scrolling has been interrupted
        },
        */
        x: false,
        y: true
      }
      vueScrollTo.scrollTo('#blindCurrent', options)
    })
  }
}
</script>

<style lang="scss">
  .gameBlindsContent {
    padding: 1vw 2vw 0px 2vw;
  }
</style>
